import Vue from 'vue'
import VueRouter from 'vue-router'

if (process.env.NODE_ENV !== 'production') {
  Vue.use(VueRouter)
}

export default new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', name: 'welcome', component: () => import('@/views/welcome') },
    { path: '/login', name: 'login', component: () => import('@/views/login') },
    { path: '/oauth/authorize', name: 'authorize', component: () => import('@/views/authorize') }
  ]
})
